<template>
  <v-container fluid grid-list-xs>
    <YesNoModal ref="YesNoModal"/>
    <ErrorModal ref="ErrorModal"></ErrorModal>
    <Loader ref="Loader"></Loader>

    <v-card>
      <v-toolbar dense color="secondary" dark>
        <v-toolbar-title>Allocated Inspections</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          v-model="searchUserString"
          placeholder="Search customers"
        ></v-text-field>
      </v-toolbar>
      <v-flex xs12>
        <v-layout row wrap>
          <v-spacer></v-spacer>
          <v-btn
            v-if="HasAccess('CUSTOMER_MANAGEMENT', 'CREATE')"
            color="success --darken-2"
            @click="$router.push('/inspection/allocate')"
          >
            <v-icon>add</v-icon>Allocate Inspection
          </v-btn>
        </v-layout>
        <v-data-table :headers="tableHeaders" :items="tableItems">
          <template slot="items" slot-scope="{ item }">
            <td>{{ filterInspection(item.CustomerInspectionID) }}</td>
            <td>{{ filterSystemUser(item.SystemUserID) }}</td>
            <td>{{ formatDate(item.Date) }}</td>
            <td style="float:right;">
              <v-menu dense bottom left>
                <v-btn small slot="activator" color="primary" dark>
                  <v-icon>settings</v-icon>
                </v-btn>

                <div
                  v-if="HasAccess('CUSTOMER_MANAGEMENT', 'MODIFY') || HasAccess('CUSTOMER_MANAGEMENT', 'DELETE')"
                >
                  <v-list dense v-for="(action, index) in actionItems" :key="index">
                    <v-list-tile
                      @click="PerformOperation(action, item)"
                      v-if="action.access == true"
                    >
                      <v-list-tile-action>
                        <v-icon color="primary darken-2">{{ action.icon }}</v-icon>
                      </v-list-tile-action>
                      <v-list-tile-title>{{ action.title }}</v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </div>
                <div v-else>
                  <v-list dense>
                    <v-list-tile>
                      <v-list-tile-title>
                        You have no options
                        available
                      </v-list-tile-title>
                    </v-list-tile>
                  </v-list>
                </div>
              </v-menu>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-card>
  </v-container>
</template>

<script>
import moment from "moment";

export default {
  data() {
    let self = this;
    return {
      inspectionDataExists: false,
      systemUserExists: false,
      searchUserString: null,
      tableHeaders: [
        { text: "Inspection Item", value: "CustomerInspectionID" },
        { text: "System User", value: "SystemUserID" },
        { text: "Date", value: "DateTime" },
        { text: "Actions", value: "ID", align: "right" }
      ],
      tableItems: [],
      InspectionList: [],
      SystemUserList: [],
      actionItems: [
        {
          type: "modify",
          title: "Modify",
          access: self.HasAccess("CUSTOMER_MANAGEMENT", "MODIFY"),
          icon: "edit"
        },
        {
          type: "delete",
          title: "Delete",
          access: self.HasAccess("CUSTOMER_MANAGEMENT", "DELETE"),
          icon: "delete"
        }
      ]
    };
  },
  computed: {
    shouldFetchAllocations() {
      return this.inspectionDataExists && this.systemUserExists;
    }
  },
  watch: {
    shouldFetchAllocations(val) {
      if (val) {
        this.fetchAllocations();
      }
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.fetchInspections();
      this.fetchSystemUsers();
    },
    fetchAllocations() {
      let self = this;

      self.get(`SupervisorAllocatedInspection`).then(r => {
        self.tableItems = r.data;
      });
    },
    fetchInspections() {
      let self = this;

      self.get(`CustomerInspection`).then(r => {
        r.data.forEach(element => {
          self.InspectionList.push(element.CustomerInspection);
        });

        self.inspectionDataExists = true;
      });
    },
    fetchSystemUsers() {
      let self = this;

      self.get(`SystemUser`).then(r => {
        self.SystemUserList = r.data;
        self.systemUserExists = true;
      });
    },
    filterInspection(id) {
      let self = this;

      let retVal = self.InspectionList.filter(el => {
        return el.ID == id;
      });

      return retVal[0].Name;
    },
    filterSystemUser(id) {
      let self = this;

      let retVal = self.SystemUserList.filter(el => {
        return el.ID == id;
      });

      let name = retVal[0].FirstName + " " + retVal[0].LastName;
      return name;
    },
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    }
  }
};
</script>

<style>
</style>
